/**
 * @desc: 供应商注册
 * @created: 2020/4/27
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http';
import qs, { stringify } from 'qs'

// 供应商注册列表数据
export const getListData = params => {
  return request.get('/supplier/query', params)
}

// 批量注册
export const postBatchRegister = data => {
  return request.post('/routemapping/bank/batchRegister', data, { json: true })
}

// 释放
export const releaseSup = params => {
  return request.post('/supplier/releaseSup', qs.stringify(params))
}